import React from 'react';
import PublicLayout from '../../components/layouts/PublicLayout';
import { useSEO, generateBreadcrumbSchema, generateWebPageSchema } from '../../hooks/useSEO';
import { usePublicTranslation } from '../../hooks/usePublicTranslation';

// Ícones para a seção de Visão
const IconFinancial = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
    </svg>
);
const IconHuman = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>
    </svg>
);
const IconTrust = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path>
    </svg>
);
const IconSuccess = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 9l6 6 6-6"></path><circle cx="12" cy="12" r="3"></circle>
    </svg>
);
const IconIntegrated = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
);

// Ícones para metodologia S.M.A.R.T.
const IconSpecific = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
    </svg>
);
const IconMeasurable = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
    </svg>
);
const IconAchievable = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
);
const IconRelevant = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
    </svg>
);
const IconTimeBound = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
);


const OverviewPage: React.FC = () => {
    const { t, currentLanguage } = usePublicTranslation();

    const overview = t?.about?.overview;

    if (!overview) return null;

    const values = [
        {
            name: overview.values?.financial?.name,
            icon: <IconFinancial />,
            description: overview.values?.financial?.description
        },
        {
            name: overview.values?.human?.name,
            icon: <IconHuman />,
            description: overview.values?.human?.description
        },
        {
            name: overview.values?.trust?.name,
            icon: <IconTrust />,
            description: overview.values?.trust?.description
        },
        {
            name: overview.values?.success?.name,
            icon: <IconSuccess />,
            description: overview.values?.success?.description
        },
        {
            name: overview.values?.integrated?.name,
            icon: <IconIntegrated />,
            description: overview.values?.integrated?.description
        }
    ];

    const smartMethodology = [
        {
            letter: 'S',
            title: overview.smart?.specific?.title,
            subtitle: overview.smart?.specific?.subtitle,
            icon: <IconSpecific />,
            items: overview.smart?.specific?.items,
            position: 'left'
        },
        {
            letter: 'M',
            title: overview.smart?.measurable?.title,
            subtitle: overview.smart?.measurable?.subtitle,
            icon: <IconMeasurable />,
            items: overview.smart?.measurable?.items,
            position: 'right'
        },
        {
            letter: 'A',
            title: overview.smart?.achievable?.title,
            subtitle: overview.smart?.achievable?.subtitle,
            icon: <IconAchievable />,
            items: overview.smart?.achievable?.items,
            position: 'left'
        },
        {
            letter: 'R',
            title: overview.smart?.relevant?.title,
            subtitle: overview.smart?.relevant?.subtitle,
            icon: <IconRelevant />,
            items: overview.smart?.relevant?.items,
            position: 'right'
        },
        {
            letter: 'T',
            title: overview.smart?.timeBound?.title,
            subtitle: overview.smart?.timeBound?.subtitle,
            icon: <IconTimeBound />,
            items: overview.smart?.timeBound?.items,
            position: 'left'
        }
    ];

    // Article Schema for SEO
    const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": "Visão Geral da NexuCapital - Mineração e Pedras Preciosas",
        "description": "Conheça nossa missão, visão, valores e abordagem SMART para maximização de ativos minerários",
        "author": {
            "@type": "Organization",
            "name": "NexuCapital Empreendimentos LTDA"
        },
        "publisher": {
            "@type": "Organization",
            "name": "NexuCapital",
            "logo": {
                "@type": "ImageObject",
                "url": "https://nexucapital.com.br/assets/logos/logo-nexucapital-principal.png"
            }
        },
        "datePublished": "2024-01-01",
        "dateModified": "2025-01-01",
        "mainEntityOfPage": "https://nexucapital.com.br/about/overview",
        "articleSection": "Sobre a Empresa",
        "keywords": "mineração, pedras preciosas, compliance, due diligence, SMART methodology",
        "image": "https://nexucapital.com.br/assets/imagens/optimized/visao.png"
    };

    useSEO({
        title: overview.title,
        description: overview.subtitle,
        path: '/about/overview',
        language: currentLanguage as 'pt-br' | 'en' | 'es',
        structuredData: [
            generateBreadcrumbSchema([
                { name: 'Home', url: '/' },
                { name: 'Sobre', url: '/about' },
                { name: 'Visão Geral', url: '/about/overview' }
            ]),
            generateWebPageSchema({
                name: overview.title,
                description: overview.subtitle,
                url: '/about/overview',
                datePublished: "2025-01-20",
                dateModified: "2025-01-20"
            }),
            articleSchema
        ]
    });

    return (
        <PublicLayout>

            <main className="flex-grow">
                {/* Hero Section */}
                <div className="bg-primary text-white py-12 md:py-20 bg-gradient-to-br from-dark to-primary-dark relative overflow-hidden">
                    <div className="container mx-auto px-4 text-center relative z-10">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold mb-4 md:mb-6 animate-fade-in-up text-transparent bg-clip-text bg-gradient-to-br from-white to-secondary">
                            {overview.title}
                        </h1>
                        <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto text-gray-200 animate-slide-up-fade">
                            {overview.subtitle}
                        </p>
                    </div>
                </div>

                {/* Mission Section */}
                <section className="py-12 md:py-20 bg-white">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
                            <div className="w-full md:w-1/2">
                                <div className="rounded-lg overflow-hidden shadow-xl md:shadow-2xl transform hover:scale-105 transition-transform duration-500">
                                    <img
                                        src="/assets/imagens/0a99fbfc-8b73-46c5-bc9a-e6ab4981ed5c.jpg"
                                        alt="Missão da NexuCapital"
                                        className="w-full h-auto object-cover"
                                    />
                                </div>
                            </div>
                            <div className="w-full md:w-1/2 space-y-4 md:space-y-6">
                                <h2 className="text-2xl md:text-3xl font-serif font-bold text-primary border-l-4 border-secondary pl-4">
                                    {overview.mission?.title}
                                </h2>
                                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                                    {overview.mission?.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Vision Section */}
                <section className="py-12 md:py-20 bg-gray-50">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12">
                            <div className="w-full md:w-1/2">
                                <div className="rounded-lg overflow-hidden shadow-xl md:shadow-2xl transform hover:scale-105 transition-transform duration-500">
                                    <img
                                        src="/assets/imagens/1a12d4c7-373d-4d7e-b025-694951ef13ef.jpg"
                                        alt="Visão da NexuCapital"
                                        className="w-full h-auto object-cover"
                                    />
                                </div>
                            </div>
                            <div className="w-full md:w-1/2 space-y-4 md:space-y-6">
                                <h2 className="text-2xl md:text-3xl font-serif font-bold text-primary border-l-4 border-secondary pl-4">
                                    {overview.vision?.title}
                                </h2>
                                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                                    {overview.vision?.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Values Section */}
                <section className="py-12 md:py-20 bg-white">
                    <div className="container mx-auto px-4">
                        <h2 className="text-2xl md:text-3xl font-serif font-bold text-primary text-center mb-8 md:mb-16">
                            {overview.valuesTitle}
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
                            {values.map((value, index) => (
                                <div
                                    key={index}
                                    className="group bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-secondary/20 flex flex-col items-center text-center"
                                >
                                    <div className="text-secondary mb-4 md:mb-6 transform group-hover:scale-110 transition-transform duration-300">
                                        {value.icon}
                                    </div>
                                    <h4 className="text-lg md:text-xl font-bold text-primary mb-3 md:mb-4 group-hover:text-secondary transition-colors">
                                        {value.name}
                                    </h4>
                                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                                        {value.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* SMART Methodology Section */}
                <section className="py-12 md:py-24 bg-gray-50 overflow-hidden">
                    <div className="container mx-auto px-4">
                        <div className="text-center max-w-4xl mx-auto mb-10 md:mb-20 space-y-4 md:space-y-6">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-primary">
                                {overview.approach?.title}
                            </h2>
                            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                                {overview.approach?.intro}
                            </p>
                        </div>

                        <div className="relative">
                            {/* Vertical Line - Desktop only */}
                            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-primary/20 via-secondary/50 to-primary/20 hidden md:block"></div>

                            {/* Mobile: Vertical line on left */}
                            <div className="absolute left-6 top-0 w-0.5 h-full bg-gradient-to-b from-primary/20 via-secondary/50 to-primary/20 md:hidden"></div>

                            <div className="space-y-6 md:space-y-16">
                                {smartMethodology.map((item, index) => (
                                    <div key={index} className={`flex flex-col md:flex-row items-stretch md:items-center ${item.position === 'left' ? 'md:flex-row' : 'md:flex-row-reverse'}`}>

                                        {/* Mobile Layout */}
                                        <div className="flex md:hidden">
                                            {/* Icon Circle - Mobile */}
                                            <div className="flex-shrink-0 w-12 flex justify-center relative z-10">
                                                <div className="w-12 h-12 bg-white rounded-full shadow-lg border-3 border-secondary flex items-center justify-center text-primary">
                                                    {item.icon}
                                                </div>
                                            </div>

                                            {/* Content Card - Mobile */}
                                            <div className="flex-1 ml-4">
                                                <div className="bg-white p-4 sm:p-5 rounded-xl shadow-lg border border-gray-100 relative">
                                                    <div className="absolute left-0 top-0 w-1 h-full bg-secondary rounded-l-xl"></div>

                                                    <div className="flex items-center gap-2 mb-2">
                                                        <span className="text-2xl text-secondary/30 font-serif font-bold">
                                                            {item.letter}
                                                        </span>
                                                        <h3 className="text-lg font-bold text-primary">
                                                            {item.title}
                                                        </h3>
                                                    </div>
                                                    <p className="text-secondary font-medium mb-3 uppercase tracking-wider text-xs">
                                                        {item.subtitle}
                                                    </p>
                                                    <ul className="space-y-2">
                                                        {item.items?.map((listItem: any, listIndex: number) => (
                                                            <li key={listIndex} className="text-gray-600 text-sm flex items-start gap-2">
                                                                {typeof listItem === 'string' ? (
                                                                    <>
                                                                        <span className="mt-1.5 w-1.5 h-1.5 bg-secondary/60 rounded-full flex-shrink-0"></span>
                                                                        <span>{listItem}</span>
                                                                    </>
                                                                ) : (
                                                                    <div className="flex flex-col">
                                                                        <span className="font-bold text-primary/80 text-sm">{listItem.title}</span>
                                                                        <span className="text-xs">{listItem.description}</span>
                                                                    </div>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Desktop Layout */}
                                        {/* Content Card - Desktop */}
                                        <div className={`hidden md:block w-full md:w-5/12 ${item.position === 'left' ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`}>
                                            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 relative group">
                                                <div className={`absolute top-0 w-2 h-full bg-secondary transition-all duration-300 ${item.position === 'left' ? 'right-0 rounded-r-xl' : 'left-0 rounded-l-xl'}`}></div>

                                                <h3 className="text-2xl font-bold text-primary mb-2 flex items-center gap-3 justify-start md:justify-inherit">
                                                    <span className="text-4xl text-secondary/20 font-serif absolute top-4 right-8 select-none">
                                                        {item.letter}
                                                    </span>
                                                    {item.title}
                                                </h3>
                                                <p className="text-secondary font-medium mb-6 uppercase tracking-wider text-sm">
                                                    {item.subtitle}
                                                </p>
                                                <ul className="space-y-3">
                                                    {item.items?.map((listItem: any, listIndex: number) => (
                                                        <li key={listIndex} className="text-gray-600 text-sm flex items-start gap-2">
                                                            {typeof listItem === 'string' ? (
                                                                <>
                                                                    <span className="mt-1.5 w-1.5 h-1.5 bg-secondary/60 rounded-full flex-shrink-0"></span>
                                                                    <span>{listItem}</span>
                                                                </>
                                                            ) : (
                                                                <div className="flex flex-col">
                                                                    <span className="font-bold text-primary/80">{listItem.title}</span>
                                                                    <span>{listItem.description}</span>
                                                                </div>
                                                            )}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>

                                        {/* Icon Circle - Desktop */}
                                        <div className="hidden md:flex w-full md:w-2/12 justify-center py-6 md:py-0 relative z-10">
                                            <div className="w-16 h-16 bg-white rounded-full shadow-lg border-4 border-secondary flex items-center justify-center text-primary transform hover:scale-110 transition-transform duration-300">
                                                {item.icon}
                                            </div>
                                        </div>

                                        {/* Empty Space for alignment - Desktop */}
                                        <div className="hidden md:block w-full md:w-5/12"></div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mt-10 md:mt-20 max-w-4xl mx-auto text-center bg-white p-6 sm:p-8 md:p-10 rounded-2xl shadow-xl border border-gray-100">
                            <p className="text-base sm:text-lg md:text-xl text-gray-700 italic mb-4 md:mb-6">
                                "{overview.approach?.footer}"
                            </p>
                            <p className="text-secondary font-bold text-sm md:text-lg uppercase tracking-widest">
                                {overview.approach?.footerEmphasis}
                            </p>
                        </div>
                    </div>
                </section>
            </main>
        </PublicLayout>
    );
};

export default OverviewPage;